/* src/app/module/service-provider/service-providers-details-2/service-providers-details-2.component.scss */
body {
  margin-left: 250px;
}
.top-container {
  display: flex;
  padding: 18px 0px 24px 0px;
  flex-direction: column;
  border-radius: 0px 0px 24px 24px;
  background: var(--Gray-100, #F2F4F7);
}
.top-content {
  gap: 16px;
}
.custom-button {
  background-color: #FF8C00;
  border: #FF8C00;
}
.btn-1 {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
  height: 40px;
}
.btn-2 {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
  height: 40px;
}
.btn-1:focus,
.btn-2:focus {
  outline: none !important;
  box-shadow: none !important;
}
.btn-1:hover,
.btn-2:hover,
.btn-mark-disable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.btn-warning-1 {
  background-color: white;
  color: #B42318;
  border: 1px solid #B42318;
}
.btn-contrast-1 {
  background-color: #fff;
  color: #000;
  border: 1px solid #D0D5DD;
}
.outlined-1 {
  background-color: #fff;
  color: #B42318;
  border-color: #B42318;
}
.outlined {
  background-color: transparent;
  color: #333;
  border-color: #333;
}
.small-1 {
  font-size: 14px;
  padding: 4px 8px;
}
.card-top {
  border-radius: 10px;
  background: white;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
  justify-content: space-between;
  padding: 14px;
}
.image {
  width: 370px;
  height: 280px;
  flex: 1 1 0;
}
.text {
  width: 65px;
  flex: 2 1 0;
}
.main-text {
  text-align: start;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  width: 385px;
}
.secondary-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--Gray-500, #667085);
}
.business-details {
  width: 234px;
  height: 75px;
  border-right: 1px solid #F2F4F7;
  margin-top: 65px;
}
.owner {
  font-size: 14px;
  font-weight: 400;
  color: #475467;
}
.user-info {
  display: flex;
  align-items: self-start;
  margin-top: 16px;
}
.username {
  font-size: 16px;
  font-weight: 500;
  color: #101828;
  margin-left: 12px;
}
.name {
  margin: 0;
}
.email {
  margin: 0;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #475467;
}
.icon-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #F2F4F7;
  overflow: hidden;
}
.badge {
  background-color: #EEF4FF;
  color: white;
  padding: 1.5px;
  border-radius: 12px;
  height: 22px;
}
.row-container {
  display: flex;
  align-items: flex-start;
}
.divider {
  width: 1px;
  height: 100%;
  background-color: #667085;
}
.main-part {
  padding: 32px 0px 40px 0px;
  border-bottom: 1px solid #EDEDED;
}
.business-info {
  margin-top: 40px;
}
.business-type-label {
  color: #475467;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
}
.business-type-value {
  font-size: 16px;
  color: #101828;
  font-weight: 500;
  margin: 0;
  margin-top: 4px;
}
.service-container div {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.service-column {
  display: flex;
  flex-direction: column;
}
.service-item {
  margin: 5px;
}
.service-name {
  font-size: 14px;
  font-weight: 400;
  color: #475467;
  line-height: 24px;
}
.icon-circle-1 {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  background-color: #D1FADF;
  border-radius: 50%;
  color: white;
  margin-right: 8px;
}
.employee-value {
  font-size: 24px;
  color: #101828;
  font-weight: 500;
  margin: 0;
  margin-top: 4px;
  margin-bottom: 40px;
}
::ng-deep .p-dialog-mask {
  background-color: rgba(8, 12, 20, 0.7);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}
.history-container {
  display: flex;
}
.history {
  right: 20px;
  top: 306px;
}
::ng-deep .p-button.p-button-text:not(:disabled):hover {
  background-color: #fff;
}
.btn-toggle {
  background-color: transparent;
  border: none;
  color: #FF8C00;
  font-weight: 600;
  cursor: pointer;
  padding: 5px;
  text-align: left;
}
.btn-toggle:hover {
  text-decoration: underline;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  height: 30px;
  width: 100px;
}
.tag.submitted {
  background-color: #FFF1E0;
  color: #D47500;
  justify-content: space-around;
}
.tag.submitted::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 2px;
  border-radius: 50%;
  background-color: #D47500;
}
.tag.approved {
  background-color: #ECFDF3;
  color: #027A48;
  justify-content: space-around;
}
.tag.approved::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 0px;
  border-radius: 50%;
  background-color: #4caf50;
}
.tag.inreview {
  background-color: #f4f4f4;
  color: #757575;
  justify-content: space-around;
}
.tag.inreview::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background-color: #757575;
}
.tag.rejected {
  background-color: #FFEAEB;
  color: #FF474D;
  justify-content: space-around;
}
.tag.rejected::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background-color: #FF474D;
}
::ng-deep .ngx-extended-pdf-viewer .toolbar {
  background-color: #f8f9fa !important;
  border-bottom: 1px solid #dee2e6 !important;
}
::ng-deep .ngx-extended-pdf-viewer .zoom {
  margin-right: 10px !important;
}
.image-viewer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 1rem;
}
.document-image {
  max-width: 100%;
  max-height: calc(100% - 50px);
  object-fit: contain;
}
.image-toolbar {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}
.review-heading {
  font-size: 20px;
  color: #000;
  font-weight: 600;
}
::ng-deep .p-timeline {
  align-items: flex-start;
}
::ng-deep .p-timeline-event-opposite,
.p-timeline-event-content {
  flex: none;
  padding: 0 1rem;
  min-width: 0px;
}
::ng-deep .p-timeline.p-timeline-vertical .p-timeline-event-content {
  padding: 0 16px;
  padding-bottom: 16px;
}
::ng-deep .p-timeline-event-opposite {
  display: none !important;
}
.p-text-secondary {
  display: flex;
  flex-direction: column;
}
.p-text-secondary strong {
  color: #000;
  font-size: 15px;
  margin-bottom: 10px;
}
::ng-deep .p-timeline .p-timeline-event-marker {
  border: 2px solid orange;
  background:
    linear-gradient(
      135deg,
      #FFD700,
      #FFA500);
}
::ng-deep .p-dialog .p-dialog-footer {
  padding: 0px 24px 32px 24px;
}
.btn {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  height: 40px;
  width: 100px;
}
.delete-btn {
  background-color: white;
  color: #B42318;
  border: 1px solid #B42318;
}
.delete-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.btn-cancel {
  background-color: white;
  color: #000;
  border: 1px solid #D0D5DD;
}
.btn-cancel:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
/*# sourceMappingURL=service-providers-details-2.component-6CK6NMFA.css.map */
